import React, { useEffect, useRef, useState } from 'react';
import { Box, Container, Grid, Typography, Button, Card, CardContent, Avatar, IconButton, Stack, useMediaQuery, TextField, useTheme } from '@mui/material';
import { Extension, EmojiEvents, GroupWork, VerifiedUser, LinkedIn, Twitter, GitHub, ArrowRightAlt } from '@mui/icons-material';
import { motion } from 'framer-motion';
import { fadeInUp, getTheme } from '../theme/theme';
import TimelineSection from './about/timeline-component';
import { CTASection } from './services/CTASection';
import aboutUsHeroImage from '../assets/images/about_us_hero_image.png';
import Particles from 'react-tsparticles';
import { loadFull } from 'tsparticles';
// Animation variants
// const fadeInUp = {
//   hidden: { opacity: 0, y: 20 },
//   visible: { opacity: 1, y: 0, transition: { duration: 0.6 } }
// };



import pankajImage from '../assets/team/pankaj.png';
import prafulImage from '../assets/team/praful.png';
//import shivangImage from '../assets/team/shivang.png';
import AboutHero from './about/about-hero';
const fadeInLeft = {
  hidden: { opacity: 0, x: -20 },
  visible: { opacity: 1, x: 0, transition: { duration: 0.6 } }
};

const fadeInRight = {
  hidden: { opacity: 0, x: 20 },
  visible: { opacity: 1, x: 0, transition: { duration: 0.6 } }
};

const staggerContainer = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};

// ParticleBackground component with fixed initialization order
const ParticleBackground = ({ theme }) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    let animationFrameId;
    let particles = [];

    // Particle class - moved to the top of the effect
    class Particle {
      constructor() {
        this.x = Math.random() * canvas.width;
        this.y = Math.random() * canvas.height;
        this.size = Math.random() * 5 + 1;
        this.speedX = Math.random() * 1 - 0.5;
        this.speedY = Math.random() * 1 - 0.5;
        this.color = theme.palette.mode === 'dark'
          ? `rgba(106, 27, 255, ${Math.random() * 0.5 + 0.1})`
          : `rgba(94, 0, 255, ${Math.random() * 0.3 + 0.05})`;
      }

      update() {
        this.x += this.speedX;
        this.y += this.speedY;

        if (this.size > 0.2) this.size -= 0.01;

        // Wrap around edges
        if (this.x < 0 || this.x > canvas.width) this.speedX *= -1;
        if (this.y < 0 || this.y > canvas.height) this.speedY *= -1;
      }

      draw() {
        ctx.fillStyle = this.color;
        ctx.beginPath();
        ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
        ctx.fill();
      }
    }

    // Initialize particles
    function initParticles() {
      particles = [];
      const particleCount = Math.min(Math.floor(canvas.width * canvas.height / 9000), 100);

      for (let i = 0; i < particleCount; i++) {
        particles.push(new Particle());
      }
    }

    // Set canvas size
    const handleResize = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
      initParticles();
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    // Connect particles with lines
    function connectParticles() {
      const maxDistance = canvas.width > 768 ? 100 : 70;

      for (let a = 0; a < particles.length; a++) {
        for (let b = a; b < particles.length; b++) {
          const dx = particles[a].x - particles[b].x;
          const dy = particles[a].y - particles[b].y;
          const distance = Math.sqrt(dx * dx + dy * dy);

          if (distance < maxDistance) {
            const opacity = 1 - (distance / maxDistance);
            ctx.strokeStyle = theme.palette.mode === 'dark'
              ? `rgba(106, 27, 255, ${opacity * 0.2})`
              : `rgba(94, 0, 255, ${opacity * 0.1})`;
            ctx.lineWidth = 1;
            ctx.beginPath();
            ctx.moveTo(particles[a].x, particles[a].y);
            ctx.lineTo(particles[b].x, particles[b].y);
            ctx.stroke();
          }
        }
      }
    }

    // Animation loop
    const animate = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      // Update and draw particles
      for (let i = 0; i < particles.length; i++) {
        particles[i].update();
        particles[i].draw();
      }

      // Connect particles with lines
      connectParticles();

      animationFrameId = requestAnimationFrame(animate);
    };

    // Start animation
    animate();

    // Cleanup
    return () => {
      window.removeEventListener('resize', handleResize);
      cancelAnimationFrame(animationFrameId);
    };
  }, [theme.palette.mode]);

  return (
    <canvas
      ref={canvasRef}
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 0,
        pointerEvents: 'none',
      }}
    />
  );
};

// Data files
const teamMembers = [
  {
    name: 'Pankaj J.',
    position: 'Director',
    image: pankajImage,
    bio: 'Experienced professional with 5+ years in business analysis and product development, skilled in translating business needs into actionable solutions, driving product strategy, and collaborating with cross-functional teams to deliver impactful digital products',
    // social: {
    //   linkedin: '#',
    //   github: '#',
    // },
  },
  {
    name: 'Praful M.',
    position: 'Director',
    image: prafulImage,
    bio: 'Seasoned software developer with 8+ years of experience in designing, building, and maintaining scalable applications, with a strong focus on clean code, performance optimization, and cross-functional collaboration to deliver high-quality software solutions.',
    // social: {
    //   linkedin: '#',
    //   twitter: '#',
    // },
  },

  // {
  //   name: 'Shivang H.',
  //   position: 'Founding Member',
  //   image: shivangImage,
  //   bio: 'Skilled in data analysis, with expertise in interpreting complex datasets, uncovering insights, and enabling data-driven decision-making through effective visualization and reporting.',
  //   // social: {
  //   //   linkedin: '#',
  //   //   github: '#',
  //   // },
  // },
  // {
  //   name: 'Emily Wilson',
  //   position: 'UX/UI Designer',
  //   image: '/images/team/emily-wilson.jpg',
  //   bio: 'Creative designer focused on user-centered design principles. Emily ensures our solutions are intuitive and beautiful.',
  //   social: {
  //     linkedin: '#',
  //     dribbble: '#',
  //   },
  // },
  // {
  //   name: 'David Kim',
  //   position: 'Product Manager',
  //   image: '/images/team/david-kim.jpg',
  //   bio: 'Product strategist with a track record of successful digital products. David bridges business needs with technical solutions.',
  //   social: {
  //     linkedin: '#',
  //   },
  // },
  // {
  //   name: 'Priya Patel',
  //   position: 'Data Scientist',
  //   image: '/images/team/priya-patel.jpg',
  //   bio: 'AI and machine learning expert. Priya develops our advanced analytics and predictive modeling solutions.',
  //   social: {
  //     linkedin: '#',
  //     github: '#',
  //   },
  // },
];

const timeline = [
  {
    year: '2012',
    event: 'Company Founded',
    description: 'NexaTech was founded with a small team of 5 people working out of a shared office space.',
  },
  {
    year: '2014',
    event: 'First Major Client',
    description: 'Secured our first enterprise client, marking our entry into the corporate solutions market.',
  },
  {
    year: '2016',
    event: 'Expanded to Europe',
    description: 'Opened our first international office in London to serve European clients.',
  },
  {
    year: '2018',
    event: 'AI Division Launched',
    description: 'Established our artificial intelligence practice to meet growing demand for smart solutions.',
  },
  {
    year: '2020',
    event: 'Remote Work Initiative',
    description: 'Successfully transitioned to a fully remote workforce while maintaining productivity.',
  },
  {
    year: '2022',
    event: '100th Employee',
    description: 'Grew our team to over 100 talented professionals across 15 countries.',
  },
];

const values = [
  {
    title: 'Innovation',
    description: 'We constantly explore new technologies and approaches to deliver cutting-edge solutions.',
    icon: <Extension fontSize="large" />,
  },
  {
    title: 'Excellence',
    description: 'We strive for the highest quality in everything we do, from code to customer service.',
    icon: <EmojiEvents fontSize="large" />,
  },
  {
    title: 'Collaboration',
    description: 'We believe the best results come from teamwork and partnership with our clients.',
    icon: <GroupWork fontSize="large" />,
  },
  {
    title: 'Integrity',
    description: 'We maintain the highest ethical standards in all our business dealings.',
    icon: <VerifiedUser fontSize="large" />,
  },
];

// Component for section headers
const SectionHeader = ({ overline, title, subtitle }) => (
  <Box sx={{ textAlign: 'center', mb: 8 }}>
    <motion.div
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.3 }}
      variants={fadeInUp}
    >
      <Typography
        variant="overline"
        sx={{
          display: 'block',
          color: 'secondary.main',
          fontWeight: 600,
          letterSpacing: 1.5,
          mb: 2,
        }}
      >
        {overline}
      </Typography>
      <Typography variant="h2" component="h2" gutterBottom sx={{
        fontWeight: 700,
        backgroundImage: 'linear-gradient(90deg, #6a1bff, #00e5ff)',
        backgroundClip: 'text',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        textFillColor: 'transparent',
      }}>
        {title}
      </Typography>
      {subtitle && (
        <Typography
          variant="h5"
          color="text.secondary"
          sx={{ maxWidth: 700, mx: 'auto' }}
        >
          {subtitle}
        </Typography>
      )}
    </motion.div>
  </Box>
);

// TeamMember component
const TeamMember = ({ member }) => (
  <motion.div variants={fadeInUp}>
    <Card sx={{
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      transition: 'all 0.3s ease',
      borderRadius: 3,
      overflow: 'hidden',
      boxShadow: 3,
      '&:hover': {
        transform: 'translateY(-8px)',
        boxShadow: 8,
      },
    }}>
      <Box
        component="img"
        src={member.image}
        alt={member.name}
        sx={{
          alignSelf: 'center',
          maxWidth: 400,
          maxHeight: 400,
          width: '100%',
          height: 'auto',
          objectFit: 'cover',
          transition: 'transform 0.6s ease',
          '&:hover': {
            transform: 'scale(1.05)',
          }
        }}
      />
      <CardContent sx={{ flexGrow: 1, p: 3 }}>
        <Typography variant="h5" component="h3" gutterBottom sx={{ fontWeight: 600 }}>
          {member.name}
        </Typography>
        <Typography
          variant="subtitle1"
          sx={{
            color: 'primary.main',
            fontWeight: 500,
            mb: 2,
            display: 'inline-block',
            position: 'relative',
            '&:after': {
              content: '""',
              position: 'absolute',
              bottom: -5,
              left: 0,
              width: '30%',
              height: 2,
              bgcolor: 'primary.main',
            }
          }}
        >
          {member.position}
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph sx={{ mb: 3 }}>
          {member.bio}
        </Typography>
        {/* <Stack direction="row" spacing={1}>
          {member.social.linkedin && (
            <IconButton
              aria-label="LinkedIn"
              href={member.social.linkedin}
              target="_blank"
              sx={{
                bgcolor: theme => theme.palette.mode === 'dark'
                  ? 'rgba(106, 27, 255, 0.1)'
                  : 'rgba(94, 0, 255, 0.05)',
                color: 'primary.main',
                '&:hover': {
                  bgcolor: 'primary.main',
                  color: 'white',
                },
              }}
            >
              <LinkedIn />
            </IconButton>
          )}
          {member.social.twitter && (
            <IconButton
              aria-label="Twitter"
              href={member.social.twitter}
              target="_blank"
              sx={{
                bgcolor: theme => theme.palette.mode === 'dark'
                  ? 'rgba(0, 229, 255, 0.1)'
                  : 'rgba(0, 229, 255, 0.05)',
                color: 'secondary.main',
                '&:hover': {
                  bgcolor: 'secondary.main',
                  color: 'white',
                },
              }}
            >
              <Twitter />
            </IconButton>
          )}
          {member.social.github && (
            <IconButton
              aria-label="GitHub"
              href={member.social.github}
              target="_blank"
              sx={{
                bgcolor: theme => theme.palette.mode === 'dark'
                  ? 'rgba(255, 255, 255, 0.1)'
                  : 'rgba(0, 0, 0, 0.05)',
                color: 'text.primary',
                '&:hover': {
                  bgcolor: 'text.primary',
                  color: 'background.paper',
                },
              }}
            >
              <GitHub />
            </IconButton>
          )}
        </Stack> */}
      </CardContent>
    </Card>
  </motion.div>
);

// Value Card component
const ValueCard = ({ value }) => (
  <motion.div variants={fadeInUp}>
    <Card sx={{
      height: '100%',
      p: 4,
      textAlign: 'center',
      transition: 'all 0.3s ease',
      borderRadius: 4,
      boxShadow: 2,
      '&:hover': {
        transform: 'translateY(-8px)',
        boxShadow: 6,
        '& .valueIcon': {
          transform: 'scale(1.1)',
        }
      },
    }}>
      <Avatar
        className="valueIcon"
        sx={{
          width: 80,
          height: 80,
          bgcolor: theme => theme.palette.mode === 'dark'
            ? 'rgba(106, 27, 255, 0.15)'
            : 'rgba(94, 0, 255, 0.08)',
          color: 'primary.main',
          mb: 3,
          mx: 'auto',
          transition: 'transform 0.3s ease',
        }}
      >
        {value.icon}
      </Avatar>
      <Typography variant="h5" component="h3" gutterBottom sx={{ fontWeight: 600 }}>
        {value.title}
      </Typography>
      <Typography variant="body1" color="text.secondary">
        {value.description}
      </Typography>
    </Card>
  </motion.div>
);

// Timeline Item component
const TimelineItem = ({ item, index }) => (
  <motion.div variants={index % 2 === 0 ? fadeInLeft : fadeInRight}>
    <Box sx={{
      position: 'relative',
      pl: { xs: 6, sm: '50%' },
      pr: { xs: 0, sm: 6 },
      mb: 6,
      textAlign: { xs: 'left', sm: index % 2 === 0 ? 'left' : 'right' },
      ml: { xs: 0, sm: index % 2 === 0 ? 0 : 'auto' },
    }}>
      <Box sx={{
        position: 'absolute',
        top: 0,
        left: { xs: 0, sm: '50%' },
        width: 48,
        height: 48,
        borderRadius: '50%',
        bgcolor: 'primary.main',
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transform: { xs: 'none', sm: 'translateX(-50%)' },
        zIndex: 1,
        fontWeight: 600,
        boxShadow: 3,
      }}>
        {item.year}
      </Box>
      <Card sx={{
        p: 4,
        position: 'relative',
        borderRadius: 3,
        boxShadow: 3,
        transition: 'all 0.3s ease',
        '&:hover': {
          transform: 'translateY(-5px)',
          boxShadow: 6,
        },
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 20,
          left: { xs: -16, sm: index % 2 === 0 ? -16 : 'auto' },
          right: { xs: 'auto', sm: index % 2 === 0 ? 'auto' : -16 },
          width: 0,
          height: 0,
          borderTop: '16px solid transparent',
          borderBottom: '16px solid transparent',
          borderLeft: { xs: '16px solid', sm: index % 2 === 0 ? '16px solid' : 'none' },
          borderRight: { xs: 'none', sm: index % 2 === 0 ? 'none' : '16px solid' },
          borderLeftColor: { xs: 'background.paper', sm: index % 2 === 0 ? 'background.paper' : 'transparent' },
          borderRightColor: { xs: 'transparent', sm: index % 2 === 0 ? 'transparent' : 'background.paper' },
        },
      }}>
        <Typography variant="h5" component="h3" gutterBottom sx={{
          fontWeight: 600,
          color: 'primary.main'
        }}>
          {item.event}
        </Typography>
        <Typography variant="body1" color="text.secondary">
          {item.description}
        </Typography>
      </Card>
    </Box>
  </motion.div>
);

// Hero Section component
const HeroSection = ({ theme }) => (
  <>
    <Box
      component="section"
      sx={{
        pt: { xs: 10, md: 16 },
        pb: { xs: 10, md: 14 },
        position: 'relative',
        overflow: 'hidden',
        // background: theme.palette.mode === 'dark'
        //   ? 'linear-gradient(135deg, rgba(10, 10, 26, 0.9) 0%, rgba(26, 26, 46, 0.9) 100%)'
        //   : 'linear-gradient(135deg, rgba(245, 247, 255, 0.9) 0%, rgba(230, 235, 255, 0.9) 100%)',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          // background: theme.palette.mode === 'dark'
          //   ? 'radial-gradient(circle at 20% 50%, rgba(106, 27, 255, 0.15) 0%, transparent 60%)'
          //   : 'radial-gradient(circle at 20% 50%, rgba(106, 27, 255, 0.08) 0%, transparent 60%)',
          zIndex: 1
        },
        '&::after': {
          content: '""',
          position: 'absolute',
          bottom: 0,
          right: 0,
          width: '70%',
          height: '70%',
          // background: theme.palette.mode === 'dark'
          //   ? 'radial-gradient(circle at 80% 80%, rgba(0, 229, 255, 0.1) 0%, transparent 50%)'
          //   : 'radial-gradient(circle at 80% 80%, rgba(0, 229, 255, 0.05) 0%, transparent 50%)',
          zIndex: 1
        }
      }}
    >

      <Container maxWidth="xl" sx={{ position: 'relative', zIndex: 2 }}>
        <Grid container spacing={{ xs: 6, md: 8 }} alignItems="center" justifyContent="space-between">
          <Grid item xs={12} md={6} lg={5}>
            <motion.div
              initial="hidden"
              animate="visible"
              variants={fadeInRight}
            >
              <Box sx={{ position: 'relative' }}>
                <Typography
                  // variant="overline"
                  sx={{
                    display: 'inline-block',
                    color: 'secondary.main',
                    fontWeight: 700,
                    letterSpacing: 1.8,
                    mb: 2,
                    position: 'relative',
                    pl: 1,
                    '&::before': {
                      content: '""',
                      position: 'absolute',
                      left: -10,
                      top: '50%',
                      width: 30,
                      height: 2,
                      backgroundColor: theme.palette.secondary.main,
                      transform: 'translateY(-50%)'
                    }
                  }}
                >
                  ABOUT US
                </Typography>
              </Box>

              <Typography
                variant="h1"
                component="h1"
                gutterBottom
                sx={{
                  fontWeight: 800,
                  mb: { xs: 3, md: 4 },
                  background: `linear-gradient(90deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text', // For Firefox
                  textFillColor: 'transparent', // For Firefox
                  fontSize: { xs: '2.75rem', sm: '3.25rem', md: '3.75rem', lg: '4.25rem' },
                  lineHeight: 1.1
                }}
              >
                Technology Partners for the Digital Age
              </Typography>
              <Typography
                variant="h5"
                component="p"
                color="text.secondary"
                paragraph
                sx={{
                  mb: 5,
                  maxWidth: '90%',
                  fontSize: { xs: '1.1rem', md: '1.25rem' },
                  lineHeight: 1.6,
                  fontWeight: 400
                }}
              >
                Soranova Technologies is a leading technology consultancy dedicated to helping businesses transform through innovative digital solutions.
              </Typography>

              <Box sx={{
                display: 'flex',
                gap: 3,
                flexWrap: { xs: 'wrap', sm: 'nowrap' }
              }}>
                {/* <Button
                  variant="contained"
                  size="large"
                  href="#service-categories"
                  sx={{
                    px: { xs: 3, md: 5 },
                    py: 2,
                    fontWeight: 600,
                    background: theme.palette.gradients.primary || `linear-gradient(90deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
                    borderRadius: '50px',
                    '&:hover': {
                      transform: 'translateY(-3px)',
                      boxShadow: `0 8px 25px ${theme.palette.primary.main}40`
                    },
                    transition: 'all 0.3s ease'
                  }}
                >
                  About Us
                </Button> */}

                <Button
                  variant="outlined"
                  size="large"
                  href="/contact"
                  sx={{
                    px: { xs: 3, md: 5 },
                    py: 2,
                    fontWeight: 600,
                    borderWidth: 2,
                    borderRadius: '50px',
                    borderColor: theme.palette.primary.main,
                    '&:hover': {
                      borderWidth: 2,
                      borderColor: theme.palette.primary.main,
                      transform: 'translateY(-3px)',
                      boxShadow: `0 8px 25px ${theme.palette.primary.main}20`
                    },
                    transition: 'all 0.3s ease'
                  }}
                >
                  Contact Us
                </Button>
              </Box>
            </motion.div>
          </Grid>

          {/* <Grid item xs={12} md={6} lg={6}>
            <motion.div
              initial={{ opacity: 0, y: 60, scale: 0.95 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              transition={{ duration: 0.8, ease: "easeOut", delay: 0.3 }}
              whileHover={{ scale: 1.03 }}
            >
              <Box
                sx={{
                  position: 'relative',
                  '&::before': {
                    content: '""',
                    position: 'absolute',
                    top: { xs: -15, md: -25 },
                    left: { xs: -15, md: -25 },
                    width: { xs: 150, md: 200 },
                    height: { xs: 150, md: 200 },
                    borderRadius: '50%',
                    background: `linear-gradient(45deg, ${theme.palette.primary.main}20, ${theme.palette.secondary.main}20)`,
                    zIndex: -1
                  },
                  '&::after': {
                    content: '""',
                    position: 'absolute',
                    bottom: { xs: -20, md: -30 },
                    right: { xs: -20, md: -30 },
                    width: { xs: 180, md: 250 },
                    height: { xs: 180, md: 250 },
                    borderRadius: '50%',
                    background: `linear-gradient(45deg, ${theme.palette.secondary.main}20, ${theme.palette.primary.main}20)`,
                    zIndex: -1
                  }
                }}
              >
                <Box
                  component="img"
                  src={aboutUsHeroImage}
                  alt="Digital Services"
                  sx={{
                    width: '964px',
                    height: '412px',
                    maxWidth: '964px',
                    maxHeight: '412px',
                    borderRadius: { xs: 3, md: 4 },
                    boxShadow: `0 25px 50px ${theme.palette.mode === 'dark' ? '#00000070' : '#6a1bff30'}`,
                    border: `1px solid ${theme.palette.mode === 'dark' ? '#ffffff15' : '#6a1bff15'}`,
                    transform: 'perspective(1500px) rotateY(-8deg)',
                    transition: 'all 0.4s ease',
                    filter: theme.palette.mode === 'dark' ? 'brightness(0.9)' : 'none',
                    '&:hover': {
                      transform: 'perspective(1500px) rotateY(-5deg) scale(1.02)',
                      boxShadow: `0 30px 60px ${theme.palette.mode === 'dark' ? '#00000080' : '#6a1bff40'}`,
                    }
                  }}
                />
              </Box>
            </motion.div>
          </Grid> */}
        </Grid>
      </Container>
    </Box>

  </>
);

// Story Section component
const StorySection = () => (
  <Box id="story" sx={{
    py: { xs: 10, md: 14 },
    bgcolor: 'background.paper',
    position: 'relative',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      height: '1px',
      background: 'linear-gradient(90deg, transparent, rgba(106, 27, 255, 0.2), transparent)',
    },
  }}>
    <Container maxWidth="lg">
      <Grid container spacing={8} alignItems="center">
        <Grid item xs={12} md={6}>
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={fadeInLeft}
          >
            <Typography
              variant="overline"
              sx={{
                display: 'block',
                color: 'primary.main',
                fontWeight: 600,
                letterSpacing: 2,
                mb: 2,
              }}
            >
              OUR STORY
            </Typography>
            <Typography variant="h2" component="h2" gutterBottom sx={{
              fontWeight: 700,
              backgroundImage: 'linear-gradient(90deg, #6a1bff, #00e5ff)',
              backgroundClip: 'text',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              textFillColor: 'transparent',
            }}>
              From Startup to Industry Leader
            </Typography>
            <Typography variant="body1" color="text.secondary" paragraph sx={{ fontSize: '1.1rem', mb: 3 }}>
              Founded in 2012, NexaTech began as a small team of passionate technologists with a vision to bridge the gap between business needs and technological innovation.
            </Typography>
            <Typography variant="body1" color="text.secondary" paragraph sx={{ fontSize: '1.1rem', mb: 3 }}>
              Over the years, we've grown into a trusted partner for businesses across industries, helping them navigate digital transformation with custom solutions that drive real results.
            </Typography>
            <Button
              variant="contained"
              size="large"
              href="#timeline"
              endIcon={<ArrowRightAlt />}
              sx={{
                mt: 3,
                py: 1.5,
                px: 4,
                borderRadius: 2,
                fontWeight: 600,
                background: 'linear-gradient(90deg, #6a1bff, #00e5ff)',
                '&:hover': {
                  background: 'linear-gradient(90deg, #5a0bef, #00d5ef)',
                  boxShadow: '0 8px 16px rgba(106, 27, 255, 0.25)',
                  transform: 'translateY(-2px)',
                },
                transition: 'all 0.3s ease',
              }}
            >
              View Our Journey
            </Button>
          </motion.div>
        </Grid>
        <Grid item xs={12} md={6}>
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={fadeInRight}
          >
            <Box
              component="img"
              src="/images/our-story.jpg"
              alt="Our Story"
              sx={{
                width: '100%',
                height: 'auto',
                borderRadius: 4,
                boxShadow: 6,
                transition: 'transform 0.5s ease, box-shadow 0.5s ease',
                '&:hover': {
                  transform: 'scale(1.02)',
                  boxShadow: 12,
                }
              }}
            />
          </motion.div>
        </Grid>
      </Grid>
    </Container>
  </Box>
);


// Values Section component
const ValuesSection = () => {
  // Add hover state tracking for enhanced interactions
  const [hoveredValue, setHoveredValue] = React.useState(null);

  return (
    <Box id="values" sx={{
      py: { xs: 10, md: 14 },
      // bgcolor: 'background.paper',
      position: 'relative',
      overflow: 'hidden', // Prevent any decorative elements from causing overflow
      '&::before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        height: '1px',
        // background: 'linear-gradient(90deg, transparent, rgba(106, 27, 255, 0.2), transparent)',
      },
      // Add decorative background elements
      '&::after': {
        content: '""',
        position: 'absolute',
        top: '50%',
        right: '-5%',
        width: '500px',
        height: '500px',
        borderRadius: '50%',
        //   background: 'radial-gradient(circle, rgba(106, 27, 255, 0.05) 0%, rgba(0, 229, 255, 0.02) 60%, transparent 70%)',
        zIndex: 0,
        transform: 'translateY(-50%)',
      }
    }}>
      {/* Add floating decorative elements */}
      <Box sx={{
        position: 'absolute',
        top: '15%',
        left: '-2%',
        width: '300px',
        height: '300px',
        //  background: 'radial-gradient(circle, rgba(0, 229, 255, 0.04) 0%, rgba(106, 27, 255, 0.02) 60%, transparent 70%)',
        zIndex: 0,
      }} />

      <Container maxWidth="xl" sx={{ position: 'relative', zIndex: 1 }}>
        <SectionHeader
          overline="OUR CULTURE"
          title="Core Values"
          subtitle="The principles that guide everything we do"
        />

        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.1 }}
          variants={staggerContainer}
        >
          <Box sx={{
            py: { xs: 6, md: 10 },
          }}>
            <Box sx={{
              display: 'grid',
              gridTemplateColumns: {
                xs: '1fr',
                sm: 'repeat(2, 1fr)',
                md: 'repeat(4, 1fr)'
              },
              gap: { xs: 4, md: 5 },
            }}>
              {values.map((value, index) => (
                <motion.div
                  key={index}
                  whileHover={{
                    scale: 1.03,
                    transition: { duration: 0.3 }
                  }}
                  onHoverStart={() => setHoveredValue(index)}
                  onHoverEnd={() => setHoveredValue(null)}
                >
                  <Card sx={{
                    height: '100%',
                    p: 4,
                    textAlign: 'center',
                    transition: 'all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
                    borderRadius: '50',
                    position: 'relative',
                    overflow: 'hidden',
                    boxShadow: hoveredValue === index ? '0 15px 30px rgba(106, 27, 255, 0.15)' : '0 6px 15px rgba(106, 27, 255, 0.08)',
                    background: hoveredValue === index ?
                      'linear-gradient(135deg, rgba(106, 27, 255, 0.03) 0%, rgba(0, 229, 255, 0.03) 100%)' :
                      'none',
                    borderColor: 'transparent',
                    borderWidth: 2,
                    borderStyle: 'solid',
                    borderImage: hoveredValue === index ?
                      'linear-gradient(135deg, rgba(106, 27, 255, 0.3), rgba(0, 229, 255, 0.3)) 1' :
                      'none',
                    '&::before': {
                      content: '""',
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      right: 0,
                      height: '4px',
                      background: 'linear-gradient(90deg, #6a1bff, #00e5ff)',
                      transform: hoveredValue === index ? 'scaleX(1)' : 'scaleX(0)',
                      transformOrigin: 'center',
                      transition: 'transform 0.4s ease',
                      borderTopLeftRadius: '16px',
                      borderTopRightRadius: '16px',
                    }
                  }}>
                    <motion.div
                      animate={hoveredValue === index ? { y: -5 } : { y: 0 }}
                      transition={{ duration: 0.3 }}
                    >
                      <Avatar
                        className="valueIcon"
                        sx={{
                          width: 90,
                          height: 90,
                          bgcolor: theme => hoveredValue === index ?
                            'rgba(106, 27, 255, 0.25)' :
                            theme.palette.mode === 'dark' ?
                              'rgba(106, 27, 255, 0.15)' :
                              'rgba(94, 0, 255, 0.08)',
                          color: hoveredValue === index ? '#fff' : 'primary.main',
                          mb: 4,
                          mx: 'auto',
                          transition: 'all 0.4s ease',
                          background: hoveredValue === index ?
                            'linear-gradient(135deg, #6a1bff, #00e5ff)' :
                            'inherit',
                          boxShadow: hoveredValue === index ?
                            '0 8px 20px rgba(106, 27, 255, 0.25)' :
                            'none',
                        }}
                      >
                        {value.icon}
                      </Avatar>

                      <Typography
                        variant="h5"
                        component="h3"
                        gutterBottom
                        sx={{
                          fontWeight: 700,
                          mb: 2,
                          fontSize: { xs: '1.3rem', md: '1.5rem' },
                          position: 'relative',
                          display: 'inline-block',
                          '&::after': {
                            content: '""',
                            position: 'absolute',
                            width: hoveredValue === index ? '100%' : '40%',
                            height: '2px',
                            background: 'linear-gradient(90deg, #6a1bff, #00e5ff)',
                            bottom: '-6px',
                            left: '50%',
                            transform: 'translateX(-50%)',
                            transition: 'width 0.3s ease',
                            borderRadius: '2px',
                          }
                        }}
                      >
                        {value.title}
                      </Typography>

                      <Typography
                        variant="body1"
                        color="text.secondary"
                        sx={{
                          fontSize: '1rem',
                          lineHeight: 1.7,
                          opacity: 0.9,
                          maxWidth: '90%',
                          mx: 'auto',
                        }}
                      >
                        {value.description}
                      </Typography>

                      {/* <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={hoveredValue === index ? 
                          { opacity: 1, y: 0 } : 
                          { opacity: 0, y: 20 }
                        }
                        transition={{ duration: 0.3 }}
                      >
                        <Box sx={{ 
                          mt: 3, 
                          pt: 2, 
                          opacity: hoveredValue === index ? 1 : 0,
                          transition: 'opacity 0.3s ease',
                        }}>
                          <Typography
                            variant="body2"
                            sx={{
                              color: 'primary.main',
                              fontWeight: 600,
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              gap: 0.5,
                            }}
                          >
                            Learn more
                            <Box 
                              component="span" 
                              sx={{ 
                                display: 'inline-flex',
                                transition: 'transform 0.2s ease',
                                transform: hoveredValue === index ? 'translateX(3px)' : 'none',
                              }}
                            >
                              →
                            </Box>
                          </Typography>
                        </Box>
                      </motion.div> */}
                    </motion.div>
                  </Card>
                </motion.div>
              ))}
            </Box>
          </Box>
        </motion.div>
      </Container>
    </Box>
  );
};
// Team Section component (completed)
const TeamSection = ({ theme }) => (
  <Box id="team" sx={{
    py: { xs: 10, md: 14 },
    position: 'relative',
    // background: theme.palette.mode === 'dark'
    //   ? 'linear-gradient(135deg, rgba(106, 27, 255, 0.12) 0%, rgba(0, 229, 255, 0.08) 100%)'
    //   : 'linear-gradient(135deg, rgba(94, 0, 255, 0.06) 0%, rgba(0, 229, 255, 0.12) 100%)',
  }}>
    <ParticleBackground theme={theme} />
    <Container maxWidth="xl" sx={{ position: 'relative', zIndex: 1 }}>
      <SectionHeader
        overline="OUR PEOPLE"
        title="Meet The Team"
        subtitle="Talented professionals who make our vision a reality"
      />

      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.1 }}
        variants={staggerContainer}
      >
        <Box sx={{
          py: { xs: 6, md: 10 },
        }}>
          <Box sx={{
            display: 'grid',
            gridTemplateColumns: {
              xs: '1fr',
              sm: 'repeat(2, 1fr)',
              md: 'repeat(2, 1fr)',
              lg: 'repeat(2, 1fr)'
            },
            gap: { xs: 4, md: 5 },
            justifyContent: 'center',
            maxWidth: { xs: '100%', sm: '800px', md: '1000px', lg: '1200px' },
            mx: 'auto'
          }}>
            {teamMembers.map((member, index) => (
              <TeamMember key={index} member={member} />
            ))}
          </Box>
        </Box>
      </motion.div>
    </Container>
  </Box>
);


// Main About Page component
const AboutPage = ({ mode }) => {
  const theme = getTheme(mode)
  // const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [particlesLoaded, setParticlesLoaded] = useState(false);

  const particlesInit = async (engine) => {
    await loadFull(engine);
  };

  const particlesLoaded$ = async (container) => {
    setParticlesLoaded(true);
  };


  return (
    <>
      <Box sx={{
        bgcolor: mode === 'light' ? 'background.default' : 'background.default',
        color: 'text.primary',
        position: 'relative',
        overflow: 'hidden',
        pb: 8
      }}>
        <Box sx={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, zIndex: 0 }}>
          <Particles
            id="tsparticles"
            init={particlesInit}
            loaded={particlesLoaded$}
            options={{
              fullScreen: { enable: false },
              background: {
                color: {
                  value: 'transparent',
                },
              },
              fpsLimit: 60,
              particles: {
                color: {
                  value: mode === 'light' ? '#6a1bff' : '#00e5ff',
                },
                links: {
                  color: mode === 'light' ? '#6a1bff' : '#00e5ff',
                  distance: 150,
                  enable: true,
                  opacity: 0.3,
                  width: 1,
                },
                collisions: {
                  enable: true,
                },
                move: {
                  direction: 'none',
                  enable: true,
                  outModes: {
                    default: 'bounce',
                  },
                  random: false,
                  speed: 0.5,
                  straight: false,
                },
                number: {
                  density: {
                    enable: true,
                    area: 800,
                  },
                  value: 40,
                },
                opacity: {
                  value: 0.3,
                },
                shape: {
                  type: 'circle',
                },
                size: {
                  value: { min: 1, max: 3 },
                },
              },
              detectRetina: true,
            }}
            style={{
              position: 'absolute',
              width: '100%',
              height: '100%',
              zIndex: 0
            }}
          />
        </Box>

        <Container maxWidth="xl" sx={{ position: 'relative', zIndex: 1 }}>
          <AboutHero mode={mode} />

          {/* <HeroSection theme={theme} /> */}
          {/* <StorySection /> */}
          {/* <TimelineSection theme={theme} /> */}
          {/*<TimelineSection theme={theme} /> */}
          <ValuesSection />
          <TeamSection theme={theme} />
          <CTASection />
        </Container>
      </Box>





    </>
  );
};

export default AboutPage;